import React from 'react';
import { useTheme } from 'styled-components';

import { BenefitType } from '@epi-constants/benefitTypes';
import {
  WellbeingIcon,
  MassageIcon,
  TransportIcon,
  LunchIcon,
  RecreationalIcon
} from 'edenred-ui';
import { IBenefitTypeIcon } from '@epi-models/pages/BenefitGroups';

export const BenefitTypeIcon = ({ benefit, color }: IBenefitTypeIcon) => {
  const { primaryBackColorLight } = useTheme();

  switch (benefit) {
    case BenefitType.Lunch:
      return <LunchIcon width={82} color={color ?? primaryBackColorLight} />;
    case BenefitType.Recreational:
      return (
        <RecreationalIcon width={82} color={color ?? primaryBackColorLight} />
      );
    case BenefitType.Transport:
      return (
        <TransportIcon width={82} color={color ?? primaryBackColorLight} />
      );
    case BenefitType.Massage:
      return <MassageIcon width={82} color={color ?? primaryBackColorLight} />;
    case BenefitType.Wellbeing:
      return (
        <WellbeingIcon width={82} color={color ?? primaryBackColorLight} />
      );
    default:
      return null;
  }
};
